import { Control, ControlType } from "./controls";
import { PropertiesData, TreeNodeV } from "./tree";
import * as t from "io-ts";
import { GlobalColorsV } from "@/types/colors";
import { TypographyPresetV } from "@/types/typography";

// Builder
export type ClipboardStatus = {
  secure: Window["isSecureContext"];
  permission: PermissionStatus | null;
};

export const ClipboardDataV = t.type({
  source: t.string,
  colors: GlobalColorsV,
  presets: t.array(TypographyPresetV),
  element: TreeNodeV
});

export type ClipboardData = t.TypeOf<typeof ClipboardDataV>;

// Element Studio
export type CopiedControl = {
  value: unknown;
  type: ControlType;
};

export type CopiedElementDesignAndSettings = {
  design: PropertiesData;
  settings: PropertiesData;
  elementTypeSlug: string;
};

type ElementStudioClipboard = {
  copiedControl: false | Control;
};

export type Clipboard = {
  copiedControlData: false | CopiedControl;
  copiedElementDesignAndSettings: false | CopiedElementDesignAndSettings;
  elementStudio: false | ElementStudioClipboard;
};
